export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const Actions={
	SET_LANGUAGE : 'SET_LANGUAGE'
}

export const setLanguage=(language: string)=> 
	(dispatch:any) =>
	 {
		dispatch({
		type:Actions.SET_LANGUAGE,
		payload:  language
        
		});
	};


